import axios, { Method } from 'axios';
import getEnv from '../env/enviroment';

const env = getEnv();
if (axios.defaults) { axios.defaults.baseURL = env.graphql_server }

interface Props {
  url: string;
  data: any;
  method: Method;
  headers?: any;
}

export async function SendRequest({ url, data, method, headers = {} }: Props) {
  return axios.request({
    url,
    data,
    method,
    headers,
  });
}
